var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"footer",staticClass:"footer"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"info"},[_vm._v("网易有道信息技术（北京）有限公司")]),_c('div',{staticClass:"info"},[_vm._v("北京市海淀区西北旺东路10号院中关村软件园二期西区7号楼A座1层")])])
}]

export { render, staticRenderFns }